module.exports = __webpack_public_path__ + "static/case-slide-1-be7ac7dba6d6f0e8aa87524a792b1f45.jpg";